
import { Dispatch, SetStateAction } from 'react';

import { Button, Modal, ModalInner } from 'components';
import { ContactProfileDetailData } from './types';
import axios from 'common/AxiosAuth';

interface ModalProps {
  data: ContactProfileDetailData | null;
  setData: Dispatch<SetStateAction<ContactProfileDetailData | null>>;
  onDeleted: () => void;
  setIsDeleteModalOpened: Dispatch<SetStateAction<boolean>>;
}

const DetailDeleteModal = ({ data, setData , onDeleted, setIsDeleteModalOpened}: ModalProps) => {
  async function onDelete() {
    if(data) {
      await axios.delete(`/api/contactprofile/${data.contactProfileId}`);
      setData(null);
      onDeleted();
      setIsDeleteModalOpened(false);
    }
  }

  function onCancel() {
    setIsDeleteModalOpened(false);
  }

  return (
    <Modal isOpened={true}>
      <ModalInner className="md:w-[400px]" title="Delete" onClickClose={onCancel}>
        <p className=" p-4 pt-0 text-body1">Are you sure you want to delete it? This operation cannot be undone.</p>
        <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
          <Button className="h-9" text="Cancel" onClick={onCancel} type="secondary" size="large" />
          <Button className="h-9 bg-red-600 border-red-600" text="Delete" onClick={onDelete} type="blue" size="large" />
        </div>
      </ModalInner>
    </Modal>
  );
};

export default DetailDeleteModal;
